/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
function a(e, n) {
  const r = (e || "").split(".");
  let t = n;
  return r.forEach((o) => {
    t = t ? t[o] : void 0;
  }), t;
}
function i(e) {
  return e.length !== void 0;
}
export {
  a as getNestedValue,
  i as isArray
};
